// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"IconButton_outerContainer__1tcad","container":"IconButton_container__1SUWP","icon":"IconButton_icon__1xbQU"};